import styled from 'styled-components'
import { bp, font } from 'lib/core/resources/helpers/styled'

export const Wrapper = styled.div<{isPDF: boolean}>`
  display: grid;
  grid-template-columns: ${props => props.isPDF ? '1fr 120px 1fr' : 'repeat(2, 1fr)'};
  background: ${props => props.theme.palette.general.grey};
  grid-gap: ${props => props.isPDF ? '2px' : '1px'};
  max-width: 500px;
  margin: auto;

  > div {
    background: ${props => props.theme.palette.general.soft};
    font: ${props => font('default', 'normal', props.isPDF ? '14px/1' : '16px/1.5')};
    max-width: 200px;
    padding: ${props => props.isPDF ? '5px 15px' : '10px 20px'};
    ${bp('sm')`
      padding: 10px 5px;
      font-size: 14px;
    `}

    &:nth-child(${props => props.isPDF ? '-n+3' : '-n+2'}) {
      font: ${props => font('default', 'bold', props.isPDF ? '12px/1' :'18px/1.5')};
      text-align: center;
      text-transform: uppercase;
      ${bp('sm')`
        font-size: 14px;
      `}
    }

    &.response {
      text-align: center;
    }
  }
`
